'use client';
import React, { useEffect, useRef } from 'react';
import createGlobe from 'cobe';

const Earth = ({
  className = '',
  theta = 0.25,
  dark = 1,
  scale = 1.1, // Base globe scale
  diffuse = 1.2,
  mapSamples = 40000,
  mapBrightness = 6,
  baseColor = [0.4, 0.6509, 1],
  markerColor = [1, 0, 0],
  glowColor = [0.2745, 0.5765, 0.898],
}) => {
  const canvasRef = useRef(null);
  const globeRef = useRef(null);

  useEffect(() => {
    let width = 0;

    const onResize = () => {
      if (canvasRef.current) {
        width = canvasRef.current.offsetWidth;
        if (globeRef.current) {
          globeRef.current.resize(width * 2, width * 2);
        }
      }
    };

    window.addEventListener('resize', onResize);
    onResize();

    let phi = 0;

    if (!globeRef.current) {
      globeRef.current = createGlobe(canvasRef.current, {
        devicePixelRatio: 2,
        width: width * 2,
        height: width * 2,
        phi: 0,
        theta,
        dark,
        scale,
        diffuse,
        mapSamples,
        mapBrightness,
        baseColor,
        markerColor,
        glowColor,
        opacity: 1,
        offset: [0, 0],
        markers: [],
        onRender: (state) => {
          state.phi = phi;
          phi += 0.003;
        },
      });
    }

    return () => {
      if (globeRef.current) {
        globeRef.current.destroy();
        globeRef.current = null;
      }
      window.removeEventListener('resize', onResize);
    };
  }, [scale, theta, dark, diffuse, mapSamples, mapBrightness, baseColor, markerColor, glowColor]);

  // Responsive container styles
  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
    width: '90%',           // fills 90% of parent
    maxWidth: '700px',      // max width on large screens
    minWidth: '250px',      // prevents it from getting too small
    margin: '0 auto',
  };

  const canvasStyle = {
    width: '100%',
    height: 'auto',
    aspectRatio: '1 / 1',   // keeps globe square
  };

  return (
    <div className={className} style={containerStyle}>
      <canvas ref={canvasRef} style={canvasStyle} />
    </div>
  );
};

export default Earth;
